import { SearchOperators } from '../../enums'
import type { OperatorRegexpCaptureGroups } from '../../regexp'
import type { SearchOperatorConfig } from '../../types'
import { matchBackOperator, matchFrontOperator } from './matchOperators'

const EMPTY_SEARCH_OPERATOR_VALUES = { operator: '', lowValue: '', highValue: '', repType: undefined } as const

/** Ignoring most scenarios of multiple values or operators. Should be handled by the regex */
export const regexpCaptureGroupsToSearchOperatorConfig = (
    groups?: OperatorRegexpCaptureGroups,
): SearchOperatorConfig => {
    if (!groups) {
        return EMPTY_SEARCH_OPERATOR_VALUES
    }

    const lowerKey = groups.key?.toLowerCase() || ''
    const equalsOrNotOperator = lowerKey.includes('not') ? SearchOperators.NOT_EQUAL_TO : SearchOperators.EQUAL_TO
    const repType = lowerKey.includes('repbuyer') ? 'BUYER' : lowerKey.includes('repseller') ? 'SELLER' : undefined

    if (groups.equalsValue) {
        return { operator: equalsOrNotOperator, lowValue: groups.equalsValue, highValue: '', repType }
    }

    if (groups.alphanum && groups.alphanumValue) {
        return { operator: equalsOrNotOperator, lowValue: groups.alphanumValue, highValue: '', repType }
    }

    if (groups.quoted && groups.quotedValue) {
        return {
            operator: equalsOrNotOperator,
            lowValue: groups.quotedValue.replace(/["|']/g, ''),
            highValue: '',
            repType,
        }
    }

    if (groups.comma && groups.commaValue) {
        return { operator: equalsOrNotOperator, lowValue: groups.commaValue, highValue: '', repType }
    }

    if (groups.rangeLowValue && groups.rangeHighValue) {
        return {
            operator: SearchOperators.BETWEEN,
            lowValue: groups.rangeLowValue,
            highValue: groups.rangeHighValue,
            repType,
        }
    }

    if (groups.frontOperator && groups.frontOperatorValue) {
        const operator = matchFrontOperator(groups.frontOperator)
        return operator
            ? { operator, lowValue: groups.frontOperatorValue, highValue: '', repType }
            : EMPTY_SEARCH_OPERATOR_VALUES
    }

    if (groups.backOperator && groups.backOperatorValue) {
        const operator = matchBackOperator(groups.backOperator)
        return operator
            ? { operator, lowValue: groups.backOperatorValue, highValue: '', repType }
            : EMPTY_SEARCH_OPERATOR_VALUES
    }

    return EMPTY_SEARCH_OPERATOR_VALUES
}

export default {}
